import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import React, { useState } from 'react';

import { GA_HEADER_HAMBURGER_ACTION } from '../../../../containers/home/domain/store/HomeStoreEn';
import { useCitySelectedContext } from '../../../../contexts/city-context/CityContext';
import NextImageV2 from '../../../../ui/components/NextImageV2';
import styles from '../styles/Header.module.scss';
import { ga_mobile_menu_open } from '../vm/HeaderStore';
import { MenuContent } from '../vm/HeaderVm';

import MobileMenuCmp from './MobileMenuCmp';

interface HeaderMobileMenuSectionProps {
  menu_content: MenuContent;
}

function HeaderMobileMenuSection({
  menu_content,
}: Readonly<HeaderMobileMenuSectionProps>): React.ReactElement {
  const citySelectedContext = useCitySelectedContext();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={styles['menu-icon']}
        onClick={(): void => {
          setIsMobileMenuOpen(prev => !prev);
          publishGa4Events(citySelectedContext.category, ga_mobile_menu_open);
        }}
      >
        <NextImageV2
          src={menu_content.open_icon.path}
          alt={menu_content.open_icon.alt_text}
          height={20}
          width={20}
          quality={100}
        />
      </button>
      <div className={styles['mobile-menu']}>
        <button
          type="button"
          aria-label="Close menu"
          className={isMobileMenuOpen ? styles['mobile-menu-overlay'] : ''}
          onClick={(): void => {
            setIsMobileMenuOpen(false);
            publishGa4Events(
              citySelectedContext.category,
              GA_HEADER_HAMBURGER_ACTION,
            );
          }}
        />
        <div
          className={`${styles['mobile-menu-component']} ${
            isMobileMenuOpen ? styles['active'] : ''
          }`}
        >
          <MobileMenuCmp
            set_is_mobile_menu_open={setIsMobileMenuOpen}
            data={menu_content}
          />
        </div>
      </div>
    </>
  );
}

export default HeaderMobileMenuSection;
